export const CREATE_OAUTH_CLIENT = "CREATE_OAUTH_CLIENT";
export const SET_OAUTH_CLIENTS = "SET_OAUTH_CLIENTS";
export const GET_OAUTH_CLIENTS = "GET_OAUTH_CLIENTS";
export const REFETCH_OAUTH_CLIENTS = "REFETCH_OAUTH_CLIENTS";

export const UPDATE_OAUTH_CLIENT = "UPDATE_OAUTH_CLIENT";
export const DELETE_OAUTH_CLIENT = "DELETE_OAUTH_CLIENT";